module.exports = __webpack_public_path__ + "static/behaved-1445440fa78ab09ffc232d243cd13d64.png";